import { MINUTE_IN_MS } from '../../graphConstants';

export const CHARGERS = {
  demo1: { id: 'IOT00120C2DF6CB1Y02', title: 'Ch-10' },
  demo2: { id: 'IOT00120C2DF6CB4D01', title: 'Ch-11' },
  demo3: { id: 'IOT00120C2DF7AA41Q5', title: 'Ch-12' },
  demo4: { id: 'IOT00120C65F7A1O7P7', title: 'Ch-13' },
  demo5: { id: 'IOT00120C2DF7AW4126', title: 'Ch-21' },
  demo6: { id: 'IOT00120C2DF7CB4C12', title: 'Ch-22' },
};

export const DEMO_METERS = {
  demo1: { id: '292b85a8-d617-4679-8d07-34d0dff50ab1', title: 'Measurement Point Node Name' },
};

export const CONSTRAINTS = {
  hc: {
    demo1: {
      id: 'b2119bd9-66fb-4819-b26b-7510c8628944',
      title: 'Breaker 21',
    },
    demo2: {
      id: 'bce54359-0dbf-4c40-b03f-5c758f21e0f2',
      title: 'Breaker 22',
    },
    demo3: {
      id: 'ee3113af-f09c-4585-8cbf-0d6ea806316f',
      title: 'Breaker 23',
    },
  },
  loadSC: {
    demo1: {
      id: 'de473dd3-3013-4a85-bc3b-bd2c35273223',
      title: 'Load Soft Constraint',
    },
  },
  powerSC: {
    demo1: {
      id: 'c550b408-8d5b-4477-9913-54c4195225d4',
      title: 'Power Soft Constraint',
    },
  },
};

export const DEMO_END_PERIOD = '2022-09-02 03:00:00';

export const DEMO_DEFAULT_INTERVAL = MINUTE_IN_MS;

export const DEMO_METER_NODES = {
  [DEMO_METERS.demo1.id]: {
    id: DEMO_METERS.demo1.id,
    staticSection: {
      nodeName: DEMO_METERS.demo1.title,
      increaseThreshold: 5,
      decreaseThreshold: 5,
      phases: {
        relativeRotation: {
          1: '1',
          2: '2',
          3: '3',
        },
        absoluteRotation: {
          1: '2',
          2: '3',
          3: '1',
        },
      },
      measurementNodeType: 'LOAD_BASED',
      externalId: 'Meter Node',
    },
    topologyNodeType: 'MEASUREMENT_POINT',
  },
};

export const DEMO_CHARGERS_NODES = {
  [CHARGERS.demo1.id]: {
    id: CHARGERS.demo1.id,
    staticSection: {
      nodeName: CHARGERS.demo1.title,
      chargerUuid: CHARGERS.demo1.id,
      phases: {
        relativeRotation: {
          1: '1',
          2: '2',
          3: '3',
        },
        absoluteRotation: {
          1: '1',
          2: '2',
          3: '3',
        },
      },
    },
    topologyNodeType: 'CHARGER',
  },
  [CHARGERS.demo2.id]: {
    id: CHARGERS.demo2.id,
    staticSection: {
      nodeName: CHARGERS.demo2.title,
      chargerUuid: CHARGERS.demo2.id,
      phases: {
        relativeRotation: {
          1: '1',
          2: '2',
          3: '3',
        },
        absoluteRotation: {
          1: '1',
          2: '2',
          3: '3',
        },
      },
    },
    topologyNodeType: 'CHARGER',
  },
  [CHARGERS.demo3.id]: {
    id: CHARGERS.demo3.id,
    staticSection: {
      nodeName: CHARGERS.demo3.title,
      chargerUuid: CHARGERS.demo3.id,
      phases: {
        relativeRotation: {
          1: '1',
          2: '2',
          3: '3',
        },
        absoluteRotation: {
          1: '1',
          2: '2',
          3: '3',
        },
      },
    },
    topologyNodeType: 'CHARGER',
  },
  [CHARGERS.demo4.id]: {
    id: CHARGERS.demo4.id,
    staticSection: {
      nodeName: CHARGERS.demo4.title,
      chargerUuid: CHARGERS.demo4.id,
      phases: {
        relativeRotation: {
          1: '1',
          2: '2',
          3: '3',
        },
        absoluteRotation: {
          1: '1',
          2: '2',
          3: '3',
        },
      },
    },
    topologyNodeType: 'CHARGER',
  },
  [CHARGERS.demo5.id]: {
    id: CHARGERS.demo5.id,
    staticSection: {
      nodeName: CHARGERS.demo5.title,
      chargerUuid: CHARGERS.demo5.id,
      phases: {
        relativeRotation: {
          1: '1',
          2: '2',
          3: '3',
        },
        absoluteRotation: {
          1: '1',
          2: '2',
          3: '3',
        },
      },
    },
    topologyNodeType: 'CHARGER',
  },
  [CHARGERS.demo6.id]: {
    id: CHARGERS.demo6.id,
    staticSection: {
      nodeName: CHARGERS.demo6.title,
      chargerUuid: CHARGERS.demo6.id,
      phases: {
        relativeRotation: {
          1: '1',
          2: '2',
          3: '3',
        },
        absoluteRotation: {
          1: '1',
          2: '2',
          3: '3',
        },
      },
    },
    topologyNodeType: 'CHARGER',
  },
};
